import React, { useState, useEffect } from 'react'
import { COLORES } from '../../../../config/colores'
import { Row, Col } from 'react-bootstrap'
import { Button } from '@material-ui/core'
import { connect } from 'react-redux'
import * as actions from '../../actions/TablaBuquesAnunciadosActions'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import moment from 'moment'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { renderSelectField } from '../../../Forms/fieldRenderers'
import { EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { FORM_LINE_UP_BUQUES } from '../../../../config/forms'

const AnunciarBuqueDialogView = (props) => {
  const { giros, estados, fechaDesde = null, fechaHasta = null, entityValues } = props
  const [selectedGiro, setSelectedGiro] = useState()
  const [selectedStatus, setSelectedStatus] = useState('')

  useEffect(() => {
    const { change: formChange, estado } = props
    if (estado === '' || !estado) {
      // estado por defecto: Anunciado
      formChange('estado', 'ANUNCIAD')
      setSelectedStatus('Anunciado')
    }
  }, [props])

  const renderGiros = () => {
    const options = giros.map((giro) => {
      return (
        <option
          value={giro.nombreCorto}
          key={giro.nombreCorto}
        >
          {giro.nombre}
        </option>
      )
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const renderEstados = () => {
    const options = estados.map((e) => {
      if (e.nombreCorto !== 'CANCELAD' && e.nombreCorto !== 'FINALIZO' && e.nombreCorto !== 'CARGANDO') {
        return (
          <option
            value={e.nombreCorto}
            key={e.nombreCorto}
          >
            {e.nombre}
          </option>
        )
      }
      return null
    })
    options.unshift((<option value={null} key={0} />))
    return options
  }

  const actualizarFechas = (fechaD, fechaH) => {
    const { change: formChange } = props
    formChange('fechaDeArriboDesde', moment(fechaD).format('DD/MM/YYYY'))
    formChange('fechaDeArriboHasta', moment(fechaH).format('DD/MM/YYYY'))
  }

  return (
    <div style={{ padding: '8px' }}>
      <Row>
        <Col md={4} style={{ marginTop: '12px' }}>
          <DatePicker
            selectRange
            disabledPast
            fechaDesde={fechaDesde || null}
            fechaHasta={fechaHasta || null}
            locale='es'
            onDateChange={actualizarFechas}
            titulo='Fechas estimadas de arribo *'
            value='fechas'
          />
        </Col>
        <Col md={5} style={{ width: '98%', display: 'flex', padding: '0 0 0 15px', margin: 0 }}>
          <Col style={{ margin: 0, padding: 0 }}>
            <EntityAutocomplete
              style={{ marginTop: '16x' }}
              name='nombre'
              label='Nombre buque'
              entity='buque'
              placeholder=''
              value={''}
              enabledOptionAdd
              optionNewEntity='Agregar nuevo buque'
            />
          </Col>
          <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', margin: 'auto 0', padding: 0, position: 'absolute', right: '8px', top: '13px' }}>
            {(entityValues && (entityValues.length === 0))
              ? <Button
                variant='contained'
                style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
                size='small'
                onClick={() => { props.agregarBuqueDialog() }}
              >
                Agregar nuevo buque
              </Button>

              : null
            }
          </div>
        </Col>
        <Col md={3}>
          <Field
            onChange={(g) => setSelectedStatus(g)}
            name='estado'
            label='Estado'
            autoFocus={false}
            component={renderSelectField}
            value={selectedStatus}
          >
            {renderEstados()}

          </Field>
        </Col>
      </Row>
      <Row style={{ marginTop: '2%' }}>
        {
          giros && giros.length > 0 && <Col md={2}>
            <Field
              onChange={(g) => setSelectedGiro(g)}
              name='giro'
              label='Giro'
              autoFocus={false}
              component={renderSelectField}
              value={selectedGiro}
            >
              {renderGiros()}
            </Field>
          </Col>
        }
        <Col md={5}>
          <EntityAutocomplete
            name='agencia'
            label='Agencia Marítima'
            entity='agencia_maritima'
            placeholder='Agencia - 19999999991'
            value={''}
          />
        </Col>
        <Col md={5}>
          <EntityAutocomplete
            name='agenciaDeEstiba'
            label='Agencia de Estiba'
            entity='agencia_de_estiba'
            placeholder='Agencia - 19999999991'
            value={''}
          />
        </Col>
        <Col md={12} style={{ textAlign: 'right', marginTop: '8px' }}>
          <p>(*) Campo requerido obligatorio</p>
        </Col>
      </Row >
    </div >
  )
}

const selector = formValueSelector(FORM_LINE_UP_BUQUES)

const mapStateToProps = (state) => ({
  anuncioInicial: state.buque.anuncioInicial,
  giros: state.buque.giros,
  estados: state.buque.estados,
  nombre: selector(state, 'nombre'),
  estado: selector(state, 'estado'),
  isRequestingGiro: state.buque.isRequestingGiro,
  entityValues: state.autocomplete.entityValues.buque
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LINE_UP_BUQUES,
  enableReinitialize: true
})

export default withRedux(withReduxForm(AnunciarBuqueDialogView))
